export default __webpack_public_path__ + "/dist/images/home-active.5b5bd4e59b50272397da0a9b134d2899.svg";